<template>
  <div>
    <v-dialog v-model="sampleOrderedSuccess" max-width="500px">
      <v-card>
        <v-card-title style="background-color: var(--accentColorShaded) !important;" class="headline grey lighten-2">
          <h2 style="color:var(--mainColor); text-align: left;">{{getText.popupTitle}}</h2>
        </v-card-title>

        <v-card-text>
          <p style="color: var(--mainColor); text-align: left; padding-top: 10px;">{{getText.popupText}}</p>
          <!-- <v-textarea
              style="margin-top: 20px;"
              color="var(--accentColor)"
              outlined
              name="input-7-1"
              :label="getText.popupLabel"
              v-model="address"
            ></v-textarea> -->

              <v-btn
                style="margin-right: 15px;"
                color="var(--mainColor)"
                text
                @click="sampleOrderedSuccess = false"
              >
                {{getText.popupButtonCancel}}
              </v-btn>
            <router-link to="/cartDesktop">
              <v-btn
                color="var(--mainColor)"
                text
              >
                {{getText.popupButtonDone}}
              </v-btn>
            </router-link>
        </v-card-text>
      </v-card>
    </v-dialog>

    <div v-if="getMobile" id="getSampleMobile" class="shadedBackground" style="position: relative;padding: 50px 0 0 0;">
      <h1 class="mobileTextPadding">
        {{getText.title}}
      </h1>
      <div style="width: 100%; height: 100vw;"  class="mobileTextPadding">
        <img src="./../../public/img/muster.jpeg" alt="Musterstück umsonst" width="100%" style="margin: 15px 0; object-fit: cover;"/>
      </div>
      <p class="mobileTextPadding">
        {{getText.text}}
      </p>
      <!-- <v-btn @click="addressPopup = true" class="ma-2" color="var(--accentColor)"> -->
      <v-btn @click="addSampleToCart()" class="ma-2" color="var(--accentColor)">
        <span style="color:var(--mainColor);">{{getText.link}}</span>
      </v-btn>
    </div>

    <div v-if="!getMobile" id="getSampleDesktop" class="centerElementBig" v-bind:class="{ accentColorShadedBackground: !desktopConfigurator}" style="padding: 100px 0; position: relative; top: -6px;">
      <div>
      </div>
      <div>
        <h1 style="margin-bottom: 40px;">
          {{getText.title}}
        </h1>
        <div id="desktopContentWrapper">
          <div style="width: 100%; height: 400px; position: relative">
            <img src="./../../public/img/muster.jpeg" alt="Musterstück umsonst" width="400px" style="position: absolute; right: 0; margin: 15px 0; object-fit: cover;"/>
          </div>
          <div style="padding: 12px 0 12px 25px; width: 400px;">
            <h3 class="mediumLineHeight" style="text-align: left;">
              {{getText.text}}
            </h3>
            <!-- <v-btn style="position: relative; top: 15px;" @click="addressPopup = true" class="ma-2" color="var(--accentColor)"> -->
            <v-btn style="position: relative; top: 15px;" @click="addSampleToCart()" class="ma-2" color="var(--accentColor)">
              <span style="color:var(--mainColor);">{{getText.link}}</span>
            </v-btn>
          </div>
        </div>
      </div>
      <div>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'ContactForm',
  components: {
    // HelloWorld
  },
  props: ['desktopConfigurator'],
  data() {
    return{
      sampleOrderedSuccess: false,
      address: ""
    }
   },
   computed: {
     getMobile(){return this.$store.getters.getAnimationProperties.mobile;},
     getText(){
       return this.$store.getters.getText.sample;
     }
   },
   methods: {
     addSampleToCart(){
       this.$store.dispatch("addSampleToCart");
       this.sampleOrderedSuccess = true;
     },
     // sendMessage(){
     //   var message = {message: this.address, messageType: "sample"}
     //   this.addressPopup = false;
     //   this.$store.dispatch("sendMessage", message);
     // },
   },
   mounted () {
   },
   watch:{
   }
}
</script>

<style scoped>
  #desktopContentWrapper{
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  #getSampleDesktop{
    padding-top: 40px;
  }
  #getSampleMobile{
    margin: 100px 0;
  }
  .shadedBackground{
    background-color: var(--accentColorShadedTransparent);
  }
</style>
